module.exports = __webpack_public_path__ + "img/vannkraft.9c7374d6.jpg";